//our root app component
import { Component, ViewChild, OnInit, Input, ComponentFactoryResolver, AfterViewInit } from '@angular/core'
import { Widget, Dashboard } from 'src/api/models'

import { WidgetService } from 'src/service/widget.service';
import { WidgetType, IWidgetEditor, } from 'src/app/models/dashboard';
import { WidgetEditorDirective } from '../../directives/widget-editor.directive';


@Component({
  selector: 'app-widget-editor',
  templateUrl: './widget-editor.component.html',
  styleUrls: ['./widget-editor.component.css']
})
export class WidgetEditorComponent implements AfterViewInit, OnInit {
  @ViewChild(WidgetEditorDirective, {}) host: WidgetEditorDirective;
  @Input() widget: Widget;
  @Input() dashboard: Dashboard;
  @Input() siteUri: string;
  widgetDetail: WidgetType;

  widgets: any;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private widgetService: WidgetService) { }

  ngOnInit() {
    this.widgets = this.widgetService.getWidgets();
  }

  ngAfterViewInit(): void {
    const widgetType: string = this.widget.type;

    this.widgetDetail = this.getWidgetDetail(widgetType);

    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.widgetDetail.editor);
      
    let viewContainerRef = this.host.viewContainerRef;
    viewContainerRef.clear();

    let componentRef = viewContainerRef.createComponent(componentFactory);
    (<IWidgetEditor>componentRef.instance).widgetType = this.widgetDetail;
    (<IWidgetEditor>componentRef.instance).widget = this.widget;
    (<IWidgetEditor>componentRef.instance).dashboard = this.dashboard;
    (<IWidgetEditor>componentRef.instance).siteUri = this.siteUri;
  }
  
  getWidgetDetail(name: string): WidgetType {
    return this.widgets.find(w => w.type === name);
  }
}
